/**
 * Table Helper Utilities
 * Shared utilities for converting data to Ant Design table format
 */

/**
 * Convert array of objects to Ant Design table format.
 *
 * @param {Array} data - Array of row objects
 * @param {Array|null} columns - Optional column names to use
 * @returns {Object} - { dataSource, columns } for Ant Design Table
 */
const arrayToTableData = (data, columns = null) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return { dataSource: [], columns: [] };
  }

  const firstRow = data[0];
  const columnKeys = columns || (typeof firstRow === 'object' ? Object.keys(firstRow) : []);

  const tableColumns = columnKeys.map((key) => ({
    title: key,
    dataIndex: key,
    key,
    ellipsis: true,
    render: (value) => {
      // Handle null/undefined
      if (value === null || value === undefined) {
        return '-';
      }
      // Handle arrays by joining elements, objects by stringifying
      if (Array.isArray(value)) {
        return value.join(', ');
      }
      if (typeof value === 'object') {
        try {
          return JSON.stringify(value);
        } catch (e) {
          return '[Complex Object]';
        }
      }
      // Return primitive values as-is
      return value;
    },
  }));

  const dataSource = data.map((row, index) => ({
    ...row,
    key: index,
  }));

  return { dataSource, columns: tableColumns };
};

export default arrayToTableData;
